import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[crmExternalEvents]',
  standalone: true
})
export class ExternalEventsDirective {
  private _elements: HTMLElement[];

  private readonly constantsClass: string[] = ['p-datepicker-not-check-external', 'p-multiselect-token-icon'];

  @Output() public onClickExternal = new EventEmitter<EventTarget>();

  @Input() public set elements(elements: HTMLElement | HTMLElement[]) {
    if (!elements) {
      this._elements = null;
      return;
    }

    if (Array.isArray(elements)) {
      this._elements = elements.filter((el) => el);
    } else {
      this._elements = [elements];
    }
  }

  public get elements(): HTMLElement[] | null {
    return this._elements;
  }

  public constructor(private readonly el: ElementRef) {}

  @HostListener('document:click', ['$event'])
  public onClick(event: Event) {
    if (
      !this.el.nativeElement.contains(event.target) &&
      ((this.elements?.length && this.elements.every((el) => !el.contains(event.target as HTMLElement))) ||
        !this.elements?.length) &&
      !this.constantsClass.some((_class) => (event.target as HTMLElement)?.classList?.contains(_class))
    ) {
      this.onClickExternal.emit(event.target);
    }
  }
}
